import { h } from 'preact'

const TopicFeaturedImage = ({ src, alt }: { src: string, alt: string }) => {
  return (
    <div className='box__pad--sides--large-only'>
      <img
        className='thread-details-featured-image qa-thread-featured-image'
        srcSet={`${src} 480w,${src} 700w,${src} 1000w,${src} 1400w,${src} 2000w`}
        sizes='(max-width: 1024px) 700px, 100vw'
        src={src}
        alt={alt}
      />
    </div>
  )
}

export default TopicFeaturedImage
